import { Clock, User, ArrowRight } from 'lucide-react'

/* Compo-statusbalk — één regel bovenaan Kempenvision/Imagecompo die
   verzamelt: waar staat de show nu, waar sta ik als deelnemer, wat is
   de eerstvolgende actie, en wanneer sluit deze fase. Vervangt de losse
   cards die om aandacht vochten. */

function relatiefTijd(iso) {
  if (!iso) return null
  const ms = new Date(iso).getTime() - Date.now()
  if (ms <= 0) return 'nu gesloten'
  const min = Math.floor(ms / 60000)
  if (min < 1) return 'sluit binnen 1 min'
  if (min < 60) return `sluit binnen ${min} min`
  const uur = Math.floor(min / 60)
  const restMin = min % 60
  if (uur < 24) return `sluit binnen ${uur}u${restMin > 0 ? ` ${restMin}m` : ''}`
  return `sluit om ${new Date(iso).toLocaleString('nl-BE', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}`
}

export default function CompoStatusStrip({ phase, phaseLabel, mineLabel, nextAction, closesAt, accent = '#B4FF39' }) {
  if (!phase && !mineLabel && !nextAction) return null
  const closes = relatiefTijd(closesAt)

  return (
    <div
      className="rounded-md border border-border bg-card px-4 py-3 mb-4
                 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm"
      style={{ borderLeft: `3px solid ${accent}` }}
    >
      {(phaseLabel || phase) && (
        <div className="flex items-center gap-2">
          <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Fase</span>
          <span className="font-semibold" style={{ color: accent }}>
            {phaseLabel || phase || 'Onbekend'}
          </span>
        </div>
      )}

      {mineLabel && (
        <div className="flex items-center gap-2">
          <User className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">Jij:</span>
          <span>{mineLabel}</span>
        </div>
      )}

      {nextAction && (
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <ArrowRight className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
          <span className="text-muted-foreground shrink-0">Volgende:</span>
          <span className="truncate">{nextAction}</span>
        </div>
      )}

      {closes && (
        <div className="flex items-center gap-1.5 font-mono text-xs text-muted-foreground ml-auto">
          <Clock className="h-3 w-3" />
          {closes}
        </div>
      )}
    </div>
  )
}
